'use strict';

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _objectSpread = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _get = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var WS = require('wavesurfer.js');
var WS__default = _interopDefault(WS);
var eventemitter3 = require('eventemitter3');
require('debounce');
var reactDom = require('react-dom');
var TimelinePlugin = /*#__PURE__*/function () {
  function TimelinePlugin(params, ws) {
    var _this = this;
    _classCallCheck(this, TimelinePlugin);
    this._onScroll = function () {
      if (_this.wrapper && _this.drawer.wrapper) {
        _this.wrapper.scrollLeft = _this.drawer.wrapper.scrollLeft;
      }
    };
    this._onRedraw = function () {
      return _this.render();
    };
    this._onReady = function () {
      var ws = _this.wavesurfer;
      _this.drawer = ws.drawer;
      _this.pixelRatio = ws.drawer.params.pixelRatio;
      _this.maxCanvasWidth = ws.drawer.maxCanvasWidth || ws.drawer.width;
      _this.maxCanvasElementWidth = ws.drawer.maxCanvasElementWidth || Math.round(_this.maxCanvasWidth / _this.pixelRatio);
      ws.drawer.wrapper.addEventListener('scroll', _this._onScroll);
      ws.on('redraw', _this._onRedraw);
      ws.on('zoom', _this._onZoom);
      _this.render();
    };
    this._onWrapperClick = function (e) {
      e.preventDefault();
      var relX = 'offsetX' in e ? e.offsetX : e.layerX;
      _this.fireEvent('click', relX / _this.wrapper.scrollWidth || 0);
    };
    this.container = 'string' == typeof params.container ? document.querySelector(params.container) : params.container;
    if (!this.container) {
      throw new Error('No container for wavesurfer timeline');
    }
    this.wavesurfer = ws;
    this.util = ws.util;
    this.params = Object.assign({}, {
      height: 20,
      notchPercentHeight: 90,
      labelPadding: 5,
      unlabeledNotchColor: '#c0c0c0',
      primaryColor: '#000',
      secondaryColor: '#c0c0c0',
      primaryFontColor: '#000',
      secondaryFontColor: '#000',
      fontFamily: 'Arial',
      fontSize: 10,
      duration: null,
      zoomDebounce: false,
      formatTimeCallback: this.defaultFormatTimeCallback,
      timeInterval: this.defaultTimeInterval,
      primaryLabelInterval: this.defaultPrimaryLabelInterval,
      secondaryLabelInterval: this.defaultSecondaryLabelInterval,
      offset: 0
    }, params);
    this.canvases = [];
    this.wrapper = null;
    this.drawer = null;
    this.pixelRatio = null;
    this.maxCanvasWidth = null;
    this.maxCanvasElementWidth = null;
    this._onZoom = this.params.zoomDebounce ? this.wavesurfer.util.debounce(function () {
      return _this.render();
    }, this.params.zoomDebounce) : function () {
      return _this.render();
    };
  }
  _createClass(TimelinePlugin, [{
    key: "init",
    value: function init() {
      if (this.wavesurfer.isReady) {
        this._onReady();
      } else {
        this.wavesurfer.once('ready', this._onReady);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unAll();
      this.wavesurfer.un('redraw', this._onRedraw);
      this.wavesurfer.un('zoom', this._onZoom);
      this.wavesurfer.un('ready', this._onReady);
      this.wavesurfer.drawer.wrapper.removeEventListener('scroll', this._onScroll);
      if (this.wrapper && this.wrapper.parentNode) {
        this.wrapper.removeEventListener('click', this._onWrapperClick);
        this.wrapper.parentNode.removeChild(this.wrapper);
        this.wrapper = null;
      }
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      var wsParams = this.wavesurfer.params;
      this.container.innerHTML = '';
      this.wrapper = this.container.appendChild(document.createElement('timeline'));
      this.util.style(this.wrapper, {
        display: 'block',
        position: 'relative',
        userSelect: 'none',
        webkitUserSelect: 'none',
        height: "".concat(this.params.height, "px")
      });
      if (wsParams.fillParent || wsParams.scrollParent) {
        this.util.style(this.wrapper, {
          width: '100%',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      }
      this.wrapper.addEventListener('click', this._onWrapperClick);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.wrapper) {
        this.createWrapper();
      }
      this.updateCanvases();
      this.updateCanvasesPositioning();
      this.renderCanvases();
    }
  }, {
    key: "addCanvas",
    value: function addCanvas() {
      var canvas = this.wrapper.appendChild(document.createElement('canvas'));
      this.canvases.push(canvas);
      this.util.style(canvas, {
        position: 'absolute',
        zIndex: 4
      });
    }
  }, {
    key: "removeCanvas",
    value: function removeCanvas() {
      var canvas = this.canvases.pop();
      canvas.parentElement.removeChild(canvas);
    }
  }, {
    key: "updateCanvases",
    value: function updateCanvases() {
      var totalWidth = Math.round(this.drawer.wrapper.scrollWidth);
      var requiredCanvases = Math.ceil(totalWidth / this.maxCanvasElementWidth);
      while (this.canvases.length < requiredCanvases) {
        this.addCanvas();
      }
      while (this.canvases.length > requiredCanvases) {
        this.removeCanvas();
      }
    }
  }, {
    key: "updateCanvasesPositioning",
    value: function updateCanvasesPositioning() {
      var _this2 = this;
      var canvasesLength = this.canvases.length;
      this.canvases.forEach(function (canvas, i) {
        var canvasWidth = i === canvasesLength - 1 ? _this2.drawer.wrapper.scrollWidth - _this2.maxCanvasElementWidth * (canvasesLength - 1) : _this2.maxCanvasElementWidth;
        canvas.width = canvasWidth * _this2.pixelRatio;
        canvas.height = (_this2.params.height + 1) * _this2.pixelRatio;
        _this2.util.style(canvas, {
          width: "".concat(canvasWidth, "px"),
          height: "".concat(_this2.params.height, "px"),
          left: "".concat(i * _this2.maxCanvasElementWidth, "px")
        });
      });
    }
  }, {
    key: "renderCanvases",
    value: function renderCanvases() {
      var _this3 = this;
      var duration = this.params.duration || this.wavesurfer.backend.getDuration();
      if (duration <= 0) {
        return;
      }
      var wsParams = this.wavesurfer.params;
      var fontSize = this.params.fontSize * wsParams.pixelRatio;
      var totalSeconds = parseInt(duration, 10) + 1;
      var width = wsParams.fillParent && !wsParams.scrollParent ? this.drawer.getWidth() : this.drawer.wrapper.scrollWidth * wsParams.pixelRatio;
      var height1 = this.params.height * this.pixelRatio;
      var height2 = this.params.height * (this.params.notchPercentHeight / 100) * this.pixelRatio;
      var pixelsPerSecond = width / duration;
      var formatTime = this.params.formatTimeCallback;
      var intervalFnOrVal = function intervalFnOrVal(option) {
        return typeof option === 'function' ? option(pixelsPerSecond) : option;
      };
      var timeInterval = intervalFnOrVal(this.params.timeInterval);
      var primaryLabelInterval = intervalFnOrVal(this.params.primaryLabelInterval);
      var secondaryLabelInterval = intervalFnOrVal(this.params.secondaryLabelInterval);
      var curPixel = pixelsPerSecond * this.params.offset;
      var curSeconds = 0;
      var i;
      var positioning = [];
      for (i = 0; i < totalSeconds / timeInterval; i++) {
        positioning.push([i, curSeconds, curPixel]);
        curSeconds += timeInterval;
        curPixel += pixelsPerSecond * timeInterval;
      }
      var renderPositions = function renderPositions(cb) {
        positioning.forEach(function (pos) {
          cb(pos[0], pos[1], pos[2]);
        });
      };
      this.setFillStyles(this.params.primaryColor);
      this.setFonts("".concat(fontSize, "px ").concat(this.params.fontFamily));
      this.setFillStyles(this.params.primaryFontColor);
      renderPositions(function (i, curSeconds, curPixel) {
        if (i % primaryLabelInterval === 0) {
          _this3.fillRect(curPixel, 0, 1, height1);
          _this3.fillText(formatTime(curSeconds, pixelsPerSecond), curPixel + _this3.params.labelPadding * _this3.pixelRatio, height1);
        }
      });
      this.setFillStyles(this.params.secondaryColor);
      this.setFonts("".concat(fontSize, "px ").concat(this.params.fontFamily));
      this.setFillStyles(this.params.secondaryFontColor);
      renderPositions(function (i, curSeconds, curPixel) {
        if (i % secondaryLabelInterval === 0) {
          _this3.fillRect(curPixel, 0, 1, height1);
          _this3.fillText(formatTime(curSeconds, pixelsPerSecond), curPixel + _this3.params.labelPadding * _this3.pixelRatio, height1);
        }
      });
      this.setFillStyles(this.params.unlabeledNotchColor);
      renderPositions(function (i, curSeconds, curPixel) {
        if (i % secondaryLabelInterval !== 0 && i % primaryLabelInterval !== 0) {
          _this3.fillRect(curPixel, 0, 1, height2);
        }
      });
    }
  }, {
    key: "setFillStyles",
    value: function setFillStyles(fillStyle) {
      this.canvases.forEach(function (canvas) {
        canvas.getContext('2d').fillStyle = fillStyle;
      });
    }
  }, {
    key: "setFonts",
    value: function setFonts(font) {
      this.canvases.forEach(function (canvas) {
        canvas.getContext('2d').font = font;
      });
    }
  }, {
    key: "fillRect",
    value: function fillRect(x, y, width, height) {
      var _this4 = this;
      this.canvases.forEach(function (canvas, i) {
        var leftOffset = i * _this4.maxCanvasWidth;
        var intersection = {
          x1: Math.max(x, i * _this4.maxCanvasWidth),
          y1: y,
          x2: Math.min(x + width, i * _this4.maxCanvasWidth + canvas.width),
          y2: y + height
        };
        if (intersection.x1 < intersection.x2) {
          canvas.getContext('2d').fillRect(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1);
        }
      });
    }
  }, {
    key: "fillText",
    value: function fillText(text, x, y) {
      var textWidth;
      var xOffset = 0;
      this.canvases.forEach(function (canvas) {
        var context = canvas.getContext('2d');
        var canvasWidth = context.canvas.width;
        if (xOffset > x + textWidth) {
          return;
        }
        if (xOffset + canvasWidth > x) {
          textWidth = context.measureText(text).width;
          context.fillText(text, x - xOffset, y);
        }
        xOffset += canvasWidth;
      });
    }
  }, {
    key: "defaultFormatTimeCallback",
    value: function defaultFormatTimeCallback(seconds, pxPerSec) {
      if (seconds / 60 > 1) {
        var minutes = parseInt(seconds / 60, 10);
        seconds = parseInt(seconds % 60, 10);
        seconds = seconds < 10 ? '0' + seconds : seconds;
        return "".concat(minutes, ":").concat(seconds);
      }
      return Math.round(seconds * 1000) / 1000;
    }
  }, {
    key: "defaultTimeInterval",
    value: function defaultTimeInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 1;
      } else if (pxPerSec * 5 >= 25) {
        return 5;
      } else if (pxPerSec * 15 >= 25) {
        return 15;
      }
      return Math.ceil(0.5 / pxPerSec) * 60;
    }
  }, {
    key: "defaultPrimaryLabelInterval",
    value: function defaultPrimaryLabelInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 10;
      } else if (pxPerSec * 5 >= 25) {
        return 6;
      } else if (pxPerSec * 15 >= 25) {
        return 4;
      }
      return 4;
    }
  }, {
    key: "defaultSecondaryLabelInterval",
    value: function defaultSecondaryLabelInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 5;
      } else if (pxPerSec * 5 >= 25) {
        return 2;
      } else if (pxPerSec * 15 >= 25) {
        return 2;
      }
      return 2;
    }
  }], [{
    key: "create",
    value: function create(params) {
      return {
        name: 'timeline',
        deferInit: params && params.deferInit ? params.deferInit : false,
        params: params,
        instance: TimelinePlugin
      };
    }
  }]);
  return TimelinePlugin;
}();
function defaultTimeFormatter(seconds) {
  var secondsAbs = Math.abs(seconds);
  var h = Math.floor(secondsAbs / 3600);
  var m = Math.floor(secondsAbs % 3600 / 60);
  var s = Math.floor(secondsAbs % 60);
  var formattedTime = h > 0 ? h < 10 ? "0".concat(h, ":") : "".concat(h, ":") : "";
  formattedTime += m < 10 ? "0".concat(m, ":") : "".concat(m, ":");
  formattedTime += s < 10 ? "0".concat(s) : "".concat(s);
  return seconds >= 0 ? formattedTime : "-" + formattedTime;
}
var defaultTimelineOptions = {
  notchPercentHeight: 60,
  height: 12,
  fontSize: 10,
  primaryLabelInterval: 10,
  secondaryLabelInterval: 0,
  formatTimeCallback: defaultTimeFormatter
};
var TimelinePlugin$1 = TimelinePlugin;
function getId(prefix) {
  if (prefix === undefined) {
    prefix = 'wavesurfer_';
  }
  return prefix + Math.random().toString(32).substring(2);
}
function max(values) {
  var largest = -Infinity;
  Object.keys(values).forEach(function (i) {
    if (values[i] > largest) {
      largest = values[i];
    }
  });
  return largest;
}
function min(values) {
  var smallest = Number(Infinity);
  Object.keys(values).forEach(function (i) {
    if (values[i] < smallest) {
      smallest = values[i];
    }
  });
  return smallest;
}
function absMax(values) {
  var max$1 = max(values);
  var min$1 = min(values);
  return -min$1 > max$1 ? -min$1 : max$1;
}
var Observer = /*#__PURE__*/function () {
  function Observer() {
    _classCallCheck(this, Observer);
    this._disabledEventEmissions = [];
    this.handlers = null;
  }
  _createClass(Observer, [{
    key: "on",
    value: function on(event, fn) {
      var _this5 = this;
      if (!this.handlers) {
        this.handlers = {};
      }
      var handlers = this.handlers[event];
      if (!handlers) {
        handlers = this.handlers[event] = [];
      }
      handlers.push(fn);
      return {
        name: event,
        callback: fn,
        un: function un(e, fn) {
          return _this5.un(e, fn);
        }
      };
    }
  }, {
    key: "un",
    value: function un(event, fn) {
      if (!this.handlers) {
        return;
      }
      var handlers = this.handlers[event];
      var i;
      if (handlers) {
        if (fn) {
          for (i = handlers.length - 1; i >= 0; i--) {
            if (handlers[i] == fn) {
              handlers.splice(i, 1);
            }
          }
        } else {
          handlers.length = 0;
        }
      }
    }
  }, {
    key: "unAll",
    value: function unAll() {
      this.handlers = null;
    }
  }, {
    key: "once",
    value: function once(event, handler) {
      var _this6 = this;
      var fn = function fn() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        handler.apply(_this6, args);
        setTimeout(function () {
          _this6.un(event, fn);
        }, 0);
      };
      return this.on(event, fn);
    }
  }, {
    key: "setDisabledEventEmissions",
    value: function setDisabledEventEmissions(eventNames) {
      this._disabledEventEmissions = eventNames;
    }
  }, {
    key: "_isDisabledEventEmission",
    value: function _isDisabledEventEmission(event) {
      return this._disabledEventEmissions && this._disabledEventEmissions.includes(event);
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(event) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (!this.handlers || this._isDisabledEventEmission(event)) {
        return;
      }
      var handlers = this.handlers[event];
      handlers && handlers.forEach(function (fn) {
        fn.apply(void 0, args);
      });
    }
  }]);
  return Observer;
}();
function _style(el, styles) {
  Object.keys(styles).forEach(function (prop) {
    if (el.style[prop] !== styles[prop]) {
      el.style[prop] = styles[prop];
    }
  });
  return el;
}
var reqAnimationFrame = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback, element) {
  return setTimeout(callback, 1000 / 60);
}).bind(window);
function frame(func) {
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return reqAnimationFrame(function () {
      return func.apply(void 0, args);
    });
  };
}
function clamp(val, min, max) {
  return Math.min(Math.max(min, val), max);
}
var Drawer = /*#__PURE__*/function (_Observer) {
  _inherits(Drawer, _Observer);
  var _super = _createSuper(Drawer);
  function Drawer(container, params) {
    var _this7;
    _classCallCheck(this, Drawer);
    _this7 = _super.call(this);
    _this7.container = container;
    _this7.params = params;
    _this7.width = 0;
    _this7.height = params.height * _this7.params.pixelRatio;
    _this7.lastPos = 0;
    _this7.wrapper = null;
    return _this7;
  }
  _createClass(Drawer, [{
    key: "style",
    value: function style(el, styles) {
      return _style(el, styles);
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      this.wrapper = this.container.appendChild(document.createElement('wave'));
      this.style(this.wrapper, {
        display: 'block',
        position: 'relative',
        userSelect: 'none',
        webkitUserSelect: 'none',
        height: this.params.height + 'px'
      });
      if (this.params.fillParent || this.params.scrollParent) {
        this.style(this.wrapper, {
          width: '100%',
          overflowX: this.params.hideScrollbar ? 'hidden' : 'auto',
          overflowY: 'hidden'
        });
      }
      this.setupWrapperEvents();
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e, noPrevent) {
      !noPrevent && e.preventDefault();
      var clientX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
      var bbox = this.wrapper.getBoundingClientRect();
      var nominalWidth = this.width;
      var parentWidth = this.getWidth();
      var progress;
      if (!this.params.fillParent && nominalWidth < parentWidth) {
        progress = (this.params.rtl ? bbox.right - clientX : clientX - bbox.left) * (this.params.pixelRatio / nominalWidth) || 0;
      } else {
        progress = ((this.params.rtl ? bbox.right - clientX : clientX - bbox.left) + this.wrapper.scrollLeft) / this.wrapper.scrollWidth || 0;
      }
      return clamp(progress, 0, 1);
    }
  }, {
    key: "setupWrapperEvents",
    value: function setupWrapperEvents() {
      var _this8 = this;
      this.wrapper.addEventListener('click', function (e) {
        var scrollbarHeight = _this8.wrapper.offsetHeight - _this8.wrapper.clientHeight;
        if (scrollbarHeight !== 0) {
          var bbox = _this8.wrapper.getBoundingClientRect();
          if (e.clientY >= bbox.bottom - scrollbarHeight) {
            return;
          }
        }
        if (_this8.params.interact) {
          _this8.fireEvent('click', e, _this8.handleEvent(e));
        }
      });
      this.wrapper.addEventListener('dblclick', function (e) {
        if (_this8.params.interact) {
          _this8.fireEvent('dblclick', e, _this8.handleEvent(e));
        }
      });
      this.wrapper.addEventListener('scroll', function (e) {
        return _this8.fireEvent('scroll', e);
      });
    }
  }, {
    key: "drawPeaks",
    value: function drawPeaks(peaks, length, start, end) {
      if (!this.setWidth(length)) {
        this.clearWave();
      }
      this.params.barWidth ? this.drawBars(peaks, 0, start, end) : this.drawWave(peaks, 0, start, end);
    }
  }, {
    key: "resetScroll",
    value: function resetScroll() {
      if (this.wrapper !== null) {
        this.wrapper.scrollLeft = 0;
      }
    }
  }, {
    key: "recenter",
    value: function recenter(percent) {
      var position = this.wrapper.scrollWidth * percent;
      this.recenterOnPosition(position, true);
    }
  }, {
    key: "recenterOnPosition",
    value: function recenterOnPosition(position, immediate) {
      var scrollLeft = this.wrapper.scrollLeft;
      var half = ~~(this.wrapper.clientWidth / 2);
      var maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
      var target = position - half;
      var offset = target - scrollLeft;
      if (maxScroll == 0) {
        return;
      }
      if (!immediate && -half <= offset && offset < half) {
        var rate = this.params.autoCenterRate;
        rate /= half;
        rate *= maxScroll;
        offset = Math.max(-rate, Math.min(rate, offset));
        target = scrollLeft + offset;
      }
      target = Math.max(0, Math.min(maxScroll, target));
      if (target != scrollLeft) {
        this.wrapper.scrollLeft = target;
      }
    }
  }, {
    key: "getScrollX",
    value: function getScrollX() {
      var x = 0;
      if (this.wrapper) {
        var pixelRatio = this.params.pixelRatio;
        x = Math.round(this.wrapper.scrollLeft * pixelRatio);
        if (this.params.scrollParent) {
          var maxScroll = ~~(this.wrapper.scrollWidth * pixelRatio - this.getWidth());
          x = Math.min(maxScroll, Math.max(0, x));
        }
      }
      return x;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return Math.round(this.container.clientWidth * this.params.pixelRatio);
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      if (this.width == width) {
        return false;
      }
      this.width = width;
      if (this.params.fillParent || this.params.scrollParent) {
        this.style(this.wrapper, {
          width: ''
        });
      } else {
        this.style(this.wrapper, {
          width: ~~(this.width / this.params.pixelRatio) + 'px'
        });
      }
      this.updateSize();
      return true;
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      if (height == this.height) {
        return false;
      }
      this.height = height;
      this.style(this.wrapper, {
        height: ~~(this.height / this.params.pixelRatio) + 'px'
      });
      this.updateSize();
      return true;
    }
  }, {
    key: "progress",
    value: function progress(_progress) {
      var minPxDelta = 1 / this.params.pixelRatio;
      var pos = Math.round(_progress * this.width) * minPxDelta;
      if (pos < this.lastPos || pos - this.lastPos >= minPxDelta) {
        this.lastPos = pos;
        if (this.params.scrollParent && this.params.autoCenter) {
          var newPos = ~~(this.wrapper.scrollWidth * _progress);
          this.recenterOnPosition(newPos, this.params.autoCenterImmediately);
        }
        this.updateProgress(pos);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unAll();
      if (this.wrapper) {
        if (this.wrapper.parentNode == this.container) {
          this.container.removeChild(this.wrapper);
        }
        this.wrapper = null;
      }
    }
  }, {
    key: "updateCursor",
    value: function updateCursor() {}
  }, {
    key: "updateSize",
    value: function updateSize() {}
  }, {
    key: "drawBars",
    value: function drawBars(peaks, channelIndex, start, end) {}
  }, {
    key: "drawWave",
    value: function drawWave(peaks, channelIndex, start, end) {}
  }, {
    key: "clearWave",
    value: function clearWave() {}
  }, {
    key: "updateProgress",
    value: function updateProgress(position) {}
  }]);
  return Drawer;
}(Observer);
var CanvasEntry = /*#__PURE__*/function () {
  function CanvasEntry() {
    _classCallCheck(this, CanvasEntry);
    this.wave = null;
    this.waveCtx = null;
    this.progress = null;
    this.progressCtx = null;
    this.start = 0;
    this.end = 1;
    this.id = getId(typeof this.constructor.name !== 'undefined' ? this.constructor.name.toLowerCase() + '_' : 'canvasentry_');
    this.canvasContextAttributes = {};
  }
  _createClass(CanvasEntry, [{
    key: "initWave",
    value: function initWave(element) {
      this.wave = element;
      this.waveCtx = this.wave.getContext('2d', this.canvasContextAttributes);
    }
  }, {
    key: "initProgress",
    value: function initProgress(element) {
      this.progress = element;
      this.progressCtx = this.progress.getContext('2d', this.canvasContextAttributes);
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions(elementWidth, totalWidth, width, height) {
      this.start = this.wave.offsetLeft / totalWidth || 0;
      this.end = this.start + elementWidth / totalWidth;
      this.wave.width = width;
      this.wave.height = height;
      var elementSize = {
        width: elementWidth + 'px'
      };
      _style(this.wave, elementSize);
      if (this.hasProgressCanvas) {
        this.progress.width = width;
        this.progress.height = height;
        _style(this.progress, elementSize);
      }
    }
  }, {
    key: "clearWave",
    value: function clearWave() {
      this.waveCtx.clearRect(0, 0, this.waveCtx.canvas.width, this.waveCtx.canvas.height);
      if (this.hasProgressCanvas) {
        this.progressCtx.clearRect(0, 0, this.progressCtx.canvas.width, this.progressCtx.canvas.height);
      }
    }
  }, {
    key: "setFillStyles",
    value: function setFillStyles(waveColor, progressColor) {
      this.waveCtx.fillStyle = waveColor;
      if (this.hasProgressCanvas) {
        this.progressCtx.fillStyle = progressColor;
      }
    }
  }, {
    key: "fillRects",
    value: function fillRects(x, y, width, height, radius) {
      this.fillRectToContext(this.waveCtx, x, y, width, height, radius);
      if (this.hasProgressCanvas) {
        this.fillRectToContext(this.progressCtx, x, y, width, height, radius);
      }
    }
  }, {
    key: "fillRectToContext",
    value: function fillRectToContext(ctx, x, y, width, height, radius) {
      if (!ctx) {
        return;
      }
      if (radius) {
        this.drawRoundedRect(ctx, x, y, width, height, radius);
      } else {
        ctx.fillRect(x, y, width, height);
      }
    }
  }, {
    key: "drawRoundedRect",
    value: function drawRoundedRect(ctx, x, y, width, height, radius) {
      if (height === 0) {
        return;
      }
      if (height < 0) {
        height *= -1;
        y -= height;
      }
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "drawLines",
    value: function drawLines(peaks, absmax, halfH, offsetY, start, end) {
      this.drawLineToContext(this.waveCtx, peaks, absmax, halfH, offsetY, start, end);
      if (this.hasProgressCanvas) {
        this.drawLineToContext(this.progressCtx, peaks, absmax, halfH, offsetY, start, end);
      }
    }
  }, {
    key: "drawLineToContext",
    value: function drawLineToContext(ctx, peaks, absmax, halfH, offsetY, start, end) {
      if (!ctx) {
        return;
      }
      var length = peaks.length / 2;
      var first = Math.round(length * this.start);
      var last = Math.round(length * this.end) + 1;
      var canvasStart = first;
      var canvasEnd = last;
      var scale = this.wave.width / (canvasEnd - canvasStart - 1);
      var halfOffset = halfH + offsetY;
      var absmaxHalf = absmax / halfH;
      ctx.beginPath();
      ctx.moveTo((canvasStart - first) * scale, halfOffset);
      ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart] || 0) / absmaxHalf));
      var i, peak, h;
      for (i = canvasStart; i < canvasEnd; i++) {
        peak = peaks[2 * i] || 0;
        h = Math.round(peak / absmaxHalf);
        ctx.lineTo((i - first) * scale + this.halfPixel, halfOffset - h);
      }
      var j = canvasEnd - 1;
      for (j; j >= canvasStart; j--) {
        peak = peaks[2 * j + 1] || 0;
        h = Math.round(peak / absmaxHalf);
        ctx.lineTo((j - first) * scale + this.halfPixel, halfOffset - h);
      }
      ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart + 1] || 0) / absmaxHalf));
      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.waveCtx = null;
      this.wave = null;
      this.progressCtx = null;
      this.progress = null;
    }
  }, {
    key: "getImage",
    value: function getImage(format, quality, type) {
      var _this9 = this;
      if (type === 'blob') {
        return new Promise(function (resolve) {
          _this9.wave.toBlob(resolve, format, quality);
        });
      } else if (type === 'dataURL') {
        return this.wave.toDataURL(format, quality);
      }
    }
  }]);
  return CanvasEntry;
}();
var MultiCanvas = /*#__PURE__*/function (_Drawer) {
  _inherits(MultiCanvas, _Drawer);
  var _super2 = _createSuper(MultiCanvas);
  function MultiCanvas(container, params) {
    var _this10;
    _classCallCheck(this, MultiCanvas);
    _this10 = _super2.call(this, container, params);
    _this10.maxCanvasWidth = params.maxCanvasWidth;
    _this10.maxCanvasElementWidth = Math.round(params.maxCanvasWidth / params.pixelRatio);
    _this10.hasProgressCanvas = params.waveColor != params.progressColor;
    _this10.halfPixel = 0.5 / params.pixelRatio;
    _this10.canvases = [];
    _this10.progressWave = null;
    _this10.EntryClass = CanvasEntry;
    _this10.canvasContextAttributes = params.drawingContextAttributes;
    _this10.overlap = 2 * Math.ceil(params.pixelRatio / 2);
    _this10.barRadius = params.barRadius || 0;
    return _this10;
  }
  _createClass(MultiCanvas, [{
    key: "init",
    value: function init() {
      this.createWrapper();
      this.createElements();
    }
  }, {
    key: "createElements",
    value: function createElements() {
      this.progressWave = this.wrapper.appendChild(this.style(document.createElement('wave'), {
        position: 'absolute',
        zIndex: 3,
        left: 0,
        top: 0,
        bottom: 0,
        overflow: 'hidden',
        width: '0',
        display: 'none',
        boxSizing: 'border-box',
        borderRightStyle: 'solid',
        pointerEvents: 'none'
      }));
      this.addCanvas();
      this.updateCursor();
    }
  }, {
    key: "updateCursor",
    value: function updateCursor() {
      this.style(this.progressWave, {
        borderRightWidth: this.params.cursorWidth + 'px',
        borderRightColor: this.params.cursorColor
      });
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this11 = this;
      var totalWidth = Math.round(this.width / this.params.pixelRatio);
      var requiredCanvases = Math.ceil(totalWidth / (this.maxCanvasElementWidth + this.overlap));
      while (this.canvases.length < requiredCanvases) {
        this.addCanvas();
      }
      while (this.canvases.length > requiredCanvases) {
        this.removeCanvas();
      }
      var canvasWidth = this.maxCanvasWidth + this.overlap;
      var lastCanvas = this.canvases.length - 1;
      this.canvases.forEach(function (entry, i) {
        if (i == lastCanvas) {
          canvasWidth = _this11.width - _this11.maxCanvasWidth * lastCanvas;
        }
        _this11.updateDimensions(entry, canvasWidth, _this11.height);
        entry.clearWave();
      });
    }
  }, {
    key: "addCanvas",
    value: function addCanvas() {
      var entry = new this.EntryClass();
      entry.canvasContextAttributes = this.canvasContextAttributes;
      entry.hasProgressCanvas = this.hasProgressCanvas;
      entry.halfPixel = this.halfPixel;
      var leftOffset = this.maxCanvasElementWidth * this.canvases.length;
      entry.initWave(this.wrapper.appendChild(this.style(document.createElement('canvas'), {
        position: 'absolute',
        zIndex: 2,
        left: leftOffset + 'px',
        top: 0,
        bottom: 0,
        height: '100%',
        pointerEvents: 'none'
      })));
      if (this.hasProgressCanvas) {
        entry.initProgress(this.progressWave.appendChild(this.style(document.createElement('canvas'), {
          position: 'absolute',
          left: leftOffset + 'px',
          top: 0,
          bottom: 0,
          height: '100%'
        })));
      }
      this.canvases.push(entry);
    }
  }, {
    key: "removeCanvas",
    value: function removeCanvas() {
      var lastEntry = this.canvases[this.canvases.length - 1];
      lastEntry.wave.parentElement.removeChild(lastEntry.wave);
      if (this.hasProgressCanvas) {
        lastEntry.progress.parentElement.removeChild(lastEntry.progress);
      }
      if (lastEntry) {
        lastEntry.destroy();
        lastEntry = null;
      }
      this.canvases.pop();
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions(entry, width, height) {
      var elementWidth = Math.round(width / this.params.pixelRatio);
      var totalWidth = Math.round(this.width / this.params.pixelRatio);
      entry.updateDimensions(elementWidth, totalWidth, width, height);
      this.style(this.progressWave, {
        display: 'block'
      });
    }
  }, {
    key: "clearWave",
    value: function clearWave() {
      var _this12 = this;
      frame(function () {
        _this12.canvases.forEach(function (entry) {
          return entry.clearWave();
        });
      })();
    }
  }, {
    key: "drawBars",
    value: function drawBars(peaks, channelIndex, start, end) {
      var _this13 = this;
      return this.prepareDraw(peaks, channelIndex, start, end, function (_ref) {
        var absmax = _ref.absmax,
          hasMinVals = _ref.hasMinVals,
          height = _ref.height,
          offsetY = _ref.offsetY,
          halfH = _ref.halfH,
          peaks = _ref.peaks,
          ch = _ref.channelIndex;
        if (start === undefined) {
          return;
        }
        var peakIndexScale = hasMinVals ? 2 : 1;
        var length = peaks.length / peakIndexScale;
        var bar = _this13.params.barWidth * _this13.params.pixelRatio;
        var gap = _this13.params.barGap === null ? Math.max(_this13.params.pixelRatio, ~~(bar / 2)) : Math.max(_this13.params.pixelRatio, _this13.params.barGap * _this13.params.pixelRatio);
        var step = bar + gap;
        var scale = length / _this13.width;
        var first = start;
        var last = end;
        var i = first;
        for (i; i < last; i += step) {
          var peak = peaks[Math.floor(i * scale * peakIndexScale)] || 0;
          var h = Math.round(peak / absmax * halfH);
          if (h == 0 && _this13.params.barMinHeight) h = _this13.params.barMinHeight;
          _this13.fillRect(i + _this13.halfPixel, halfH - h + offsetY, bar + _this13.halfPixel, h * 2, _this13.barRadius, ch);
        }
      });
    }
  }, {
    key: "drawWave",
    value: function drawWave(peaks, channelIndex, start, end) {
      var _this14 = this;
      return this.prepareDraw(peaks, channelIndex, start, end, function (_ref2) {
        var absmax = _ref2.absmax,
          hasMinVals = _ref2.hasMinVals,
          height = _ref2.height,
          offsetY = _ref2.offsetY,
          halfH = _ref2.halfH,
          peaks = _ref2.peaks,
          channelIndex = _ref2.channelIndex;
        if (!hasMinVals) {
          var reflectedPeaks = [];
          var len = peaks.length;
          var i = 0;
          for (i; i < len; i++) {
            reflectedPeaks[2 * i] = peaks[i];
            reflectedPeaks[2 * i + 1] = -peaks[i];
          }
          peaks = reflectedPeaks;
        }
        if (start !== undefined) {
          _this14.drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex);
        }
        _this14.fillRect(0, halfH + offsetY - _this14.halfPixel, _this14.width, _this14.halfPixel, _this14.barRadius, channelIndex);
      });
    }
  }, {
    key: "drawLine",
    value: function drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex) {
      var _this15 = this;
      var _ref3 = this.params.splitChannelsOptions.channelColors[channelIndex] || {},
        waveColor = _ref3.waveColor,
        progressColor = _ref3.progressColor;
      this.canvases.forEach(function (entry, i) {
        _this15.setFillStyles(entry, waveColor, progressColor);
        entry.drawLines(peaks, absmax, halfH, offsetY, start, end);
      });
    }
  }, {
    key: "fillRect",
    value: function fillRect(x, y, width, height, radius, channelIndex) {
      var startCanvas = Math.floor(x / this.maxCanvasWidth);
      var endCanvas = Math.min(Math.ceil((x + width) / this.maxCanvasWidth) + 1, this.canvases.length);
      var i = startCanvas;
      for (i; i < endCanvas; i++) {
        var entry = this.canvases[i];
        var leftOffset = i * this.maxCanvasWidth;
        var intersection = {
          x1: Math.max(x, i * this.maxCanvasWidth),
          y1: y,
          x2: Math.min(x + width, i * this.maxCanvasWidth + entry.wave.width),
          y2: y + height
        };
        if (intersection.x1 < intersection.x2) {
          var _ref4 = this.params.splitChannelsOptions.channelColors[channelIndex] || {},
            waveColor = _ref4.waveColor,
            progressColor = _ref4.progressColor;
          this.setFillStyles(entry, waveColor, progressColor);
          entry.fillRects(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1, radius);
        }
      }
    }
  }, {
    key: "hideChannel",
    value: function hideChannel(channelIndex) {
      return this.params.splitChannels && this.params.splitChannelsOptions.filterChannels.includes(channelIndex);
    }
  }, {
    key: "prepareDraw",
    value: function prepareDraw(peaks, channelIndex, start, end, fn, drawIndex, normalizedMax) {
      var _this16 = this;
      return frame(function () {
        if (peaks[0] instanceof Array) {
          var channels = peaks;
          if (_this16.params.splitChannels) {
            var filteredChannels = channels.filter(function (c, i) {
              return !_this16.hideChannel(i);
            });
            if (!_this16.params.splitChannelsOptions.overlay) {
              _this16.setHeight(Math.max(filteredChannels.length, 1) * _this16.params.height * _this16.params.pixelRatio);
            }
            var overallAbsMax;
            if (_this16.params.splitChannelsOptions && _this16.params.splitChannelsOptions.relativeNormalization) {
              overallAbsMax = max(channels.map(function (channelPeaks) {
                return absMax(channelPeaks);
              }));
            }
            return channels.forEach(function (channelPeaks, i) {
              return _this16.prepareDraw(channelPeaks, i, start, end, fn, filteredChannels.indexOf(channelPeaks), overallAbsMax);
            });
          }
          peaks = channels[0];
        }
        if (_this16.hideChannel(channelIndex)) {
          return;
        }
        var absmax = 1 / _this16.params.barHeight;
        if (_this16.params.normalize) {
          absmax = normalizedMax === undefined ? absMax(peaks) : normalizedMax;
        }
        var hasMinVals = [].some.call(peaks, function (val) {
          return val < 0;
        });
        var height = _this16.params.height * _this16.params.pixelRatio;
        var halfH = height / 2;
        var offsetY = height * drawIndex || 0;
        if (_this16.params.splitChannelsOptions && _this16.params.splitChannelsOptions.overlay) {
          offsetY = 0;
        }
        return fn({
          absmax: absmax,
          hasMinVals: hasMinVals,
          height: height,
          offsetY: offsetY,
          halfH: halfH,
          peaks: peaks,
          channelIndex: channelIndex
        });
      })();
    }
  }, {
    key: "setFillStyles",
    value: function setFillStyles(entry) {
      var waveColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.waveColor;
      var progressColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.params.progressColor;
      entry.setFillStyles(waveColor, progressColor);
    }
  }, {
    key: "getImage",
    value: function getImage(format, quality, type) {
      if (type === 'blob') {
        return Promise.all(this.canvases.map(function (entry) {
          return entry.getImage(format, quality, type);
        }));
      } else if (type === 'dataURL') {
        var images = this.canvases.map(function (entry) {
          return entry.getImage(format, quality, type);
        });
        return images.length > 1 ? images : images[0];
      }
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(position) {
      this.style(this.progressWave, {
        width: position + 'px'
      });
    }
  }]);
  return MultiCanvas;
}(Drawer);
var regionsContainerStyles = {
  position: "absolute",
  top: "0",
  left: "0",
  zIndex: "2",
  width: "100%",
  height: "100%"
};
var segmentHighlighterContainerStyles = {
  backgroundColor: "transparent",
  width: "100%",
  height: "100%",
  position: "absolute",
  top: "0",
  left: "0",
  zIndex: "4",
  display: "flex",
  pointerEvents: "none"
};
var opacity = "0.25";
var segmentHighlighterLeftStyles = {
  width: "0",
  height: "100%",
  backgroundColor: "black",
  opacity: opacity,
  transition: "width .25s linear"
};
var segmentHighlighterCenterStyles = {
  width: "0",
  height: "100%",
  backgroundColor: "transparent",
  transition: "width .25s linear"
};
var segmentHighlighterRightStyles = {
  flex: "0",
  height: "100%",
  backgroundColor: "black",
  opacity: opacity
};
var waveStyles = {
  position: "absolute",
  zIndex: "3",
  left: "0",
  top: "0",
  bottom: "0",
  width: "0",
  display: "none",
  boxSizing: "border-box",
  pointerEvents: "none"
};
var util = WS__default.util;
var Drawer$1 = /*#__PURE__*/function (_MultiCanvas) {
  _inherits(Drawer$1, _MultiCanvas);
  var _super3 = _createSuper(Drawer$1);
  function Drawer$1(container, params) {
    var _this17;
    _classCallCheck(this, Drawer$1);
    _this17 = _super3.call(this, container, params);
    _this17.channels = [];
    _this17.currentPosition = 0;
    _this17.handleWindowResize = function () {
      _this17.fireEvent("redraw");
    };
    _this17.destroy = function () {
      window.removeEventListener("resize", _this17.handleWindowResize);
      _this17.destroyCursor();
    };
    _this17.container = container;
    _this17.params = params;
    window.addEventListener("resize", _this17.handleWindowResize);
    _this17.hasProgressCanvas = true;
    return _this17;
  }
  _createClass(Drawer$1, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(Drawer$1.prototype), "createWrapper", this).call(this);
      this.createElements();
    }
  }, {
    key: "createElements",
    value: function createElements() {
      this.progressWave = this.wrapper.appendChild(this.style(document.createElement("wave"), waveStyles));
      this.addCanvas();
      this.createCursor();
      this.wrapper.style.backgroundColor = this.params.backgroundColor;
      this.container.style.position = "relative";
      this.container.style.backgroundColor = "transparent";
    }
  }, {
    key: "drawBars",
    value: function drawBars(peaks, channelIndex, start, end) {
      if (start === undefined || end === undefined) {
        return;
      }
      return util.frame(this.prepareForDraw.bind(this))(peaks, start, end);
    }
  }, {
    key: "preparePeaks",
    value: function preparePeaks(peaks) {
      var hasMinVals = peaks.some(function (channelPeaks) {
        return channelPeaks.some(function (val) {
          return val < 0;
        });
      });
      if (hasMinVals) {
        return peaks.map(function (peaks) {
          return peaks.filter(function (_, i) {
            return !(i % 2);
          });
        });
      }
      return peaks;
    }
  }, {
    key: "prepareBars",
    value: function prepareBars(_ref5) {
      var _this18 = this;
      var start = _ref5.start,
        end = _ref5.end,
        step = _ref5.step,
        peaks = _ref5.peaks;
      var scale = peaks[0].length / this.width;
      var bars = _toConsumableArray(new Array(peaks.length)).map(function () {
        return [];
      });
      var i = start;
      var _loop = function _loop() {
        var peakIndex = Math.floor(i * scale);
        var heights = peaks.map(function (p) {
          return _this18.getPeakAverageValue(p, peakIndex, step);
        });
        heights.forEach(function (h, i) {
          return bars[i].push(h);
        });
      };
      for (i; i < end; i += step) {
        _loop();
      }
      if (this.params.normalize) {
        return this.normalizeBars(bars);
      }
      return bars;
    }
  }, {
    key: "prepareProgressBars",
    value: function prepareProgressBars(_ref6) {
      var start = _ref6.start,
        end = _ref6.end,
        step = _ref6.step;
      var i = start;
      var heights = [];
      for (i; i < end; i += step) {
        heights.push(0.5);
      }
      return [heights];
    }
  }, {
    key: "normalizeBars",
    value: function normalizeBars(bars) {
      var _this19 = this;
      return bars.map(function (barsForChannel) {
        var max = util.max(barsForChannel);
        return barsForChannel.map(function (val) {
          return _this19.params.barHeight * val / max;
        });
      });
    }
  }, {
    key: "renderBars",
    value: function renderBars(_ref7) {
      var _this20 = this;
      var bars = _ref7.bars,
        start = _ref7.start,
        step = _ref7.step;
      var height = this.params.height * this.params.pixelRatio;
      var halfH = height / 2;
      var barWidth = Math.floor(this.params.barWidth * this.params.pixelRatio);
      var channels = Array.from(bars.keys());
      bars[0].forEach(function (_, index) {
        var i = start + index * step;
        channels = channels.sort(function (a, b) {
          return bars[b][index] - bars[a][index];
        });
        channels.forEach(function (channelIndex) {
          var h = Math.round(bars[channelIndex][index] * halfH);
          if (h === 0 && _this20.params.barMinHeight) {
            h = _this20.params.barMinHeight;
          }
          _this20.fillRect(channelIndex, i + _this20.halfPixel, _this20.height - h * 2, barWidth + _this20.halfPixel, h * 2, 0);
        });
      });
    }
  }, {
    key: "prepareForDraw",
    value: function prepareForDraw(peaks, start, end) {
      var bar = this.params.barWidth * this.params.pixelRatio;
      var gap = this.params.barGap === null || this.params.barGap === undefined ? Math.max(this.params.pixelRatio, Math.floor(bar / 2)) : Math.max(this.params.pixelRatio, this.params.barGap * this.params.pixelRatio);
      var step = Math.floor(bar + gap);
      if (!peaks || !peaks.length) {
        var bars = this.prepareProgressBars({
          start: start,
          end: end,
          step: step
        });
        this.renderBars({
          bars: bars,
          start: start,
          step: step
        });
      } else {
        var processedPeaks = this.preparePeaks(peaks);
        var _bars = this.prepareBars({
          start: start,
          end: end,
          step: step,
          peaks: processedPeaks
        });
        this.renderBars({
          bars: _bars,
          start: start,
          step: step
        });
      }
    }
  }, {
    key: "fillRect",
    value: function fillRect(channelIndex, x, y, width, height, radius) {
      var startCanvas = Math.floor(x / this.maxCanvasWidth);
      var endCanvas = Math.min(Math.ceil((x + width) / this.maxCanvasWidth) + 1, this.canvases.length);
      var i = startCanvas;
      for (i; i < endCanvas; i++) {
        var entry = this.canvases[i];
        var leftOffset = i * this.maxCanvasWidth;
        var intersection = {
          x1: Math.max(x, i * this.maxCanvasWidth),
          y1: y,
          x2: Math.min(x + width, i * this.maxCanvasWidth + entry.wave.width),
          y2: y + height
        };
        if (intersection.x1 < intersection.x2) {
          this.setFillStyles(entry, channelIndex);
          entry.fillRects(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1, radius);
        }
      }
    }
  }, {
    key: "setFillStyles",
    value: function setFillStyles(entry, channelIndex) {
      var channel = this.channels[channelIndex];
      var color = channel && channel.color || this.params.waveColor;
      var progressColor = channel && channel.progressColor || channel && channel.color || this.params.progressColor;
      entry.setFillStyles(color, progressColor);
    }
  }, {
    key: "getPeakAverageValue",
    value: function getPeakAverageValue(peaks, index, radius) {
      if (index < 0) {
        return 0;
      }
      var sum = 0;
      var weightSum = 0;
      for (var i = Math.max(0, index - radius); i <= Math.min(peaks.length - 1, index + radius); i++) {
        var w = this.weightDistributionFunction(i - index, radius / 2);
        sum += w * peaks[i];
        weightSum += w;
      }
      if (weightSum === 0) {
        return 0;
      }
      var average = sum / weightSum;
      return average;
    }
  }, {
    key: "weightDistributionFunction",
    value: function weightDistributionFunction(x, deviation) {
      if (!deviation) {
        return 1;
      }
      return Math.exp(-1 * Math.pow(x / deviation, 2));
    }
  }, {
    key: "createCursor",
    value: function createCursor() {
      if (this.progressWave) {
        if (this.params.progressBackgroundColor) {
          this.style(this.progressWave, {
            backgroundColor: this.params.progressBackgroundColor
          });
        }
        this.cursorCanvas = this.style(document.createElement("canvas"), {
          position: "absolute",
          top: "0",
          left: "0",
          height: "100%",
          width: "100%",
          zIndex: "5",
          pointerEvents: "none"
        });
        this.cursorCanvas.classList.add("twilio-player-cursor");
        this.container.appendChild(this.cursorCanvas);
        var ctx = this.cursorCanvas.getContext("2d");
        if (ctx) {
          ctx.imageSmoothingEnabled = false;
          this.drawCursor(0);
        }
      }
    }
  }, {
    key: "destroyCursor",
    value: function destroyCursor() {
      var _a;
      if (this.cursorCanvas) {
        (_a = this.cursorCanvas.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.cursorCanvas);
        this.cursorCanvas = undefined;
      }
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(position) {
      position = Math.floor(position);
      if (this.progressWave) {
        this.style(this.progressWave, {
          width: position + "px"
        });
      }
      this.drawCursor(position);
    }
  }, {
    key: "drawCursor",
    value: function drawCursor(position) {
      if (this.cursorCanvas) {
        var ctx = this.cursorCanvas.getContext("2d");
        if (ctx && this.cursorCanvas) {
          ctx.imageSmoothingEnabled = false;
          this.cursorCanvas.width = this.container.clientWidth;
          this.cursorCanvas.height = this.container.clientHeight;
          ctx.clearRect(0, 0, this.cursorCanvas.width, this.cursorCanvas.height);
          ctx.fillStyle = this.params.cursorColor;
          ctx.beginPath();
          ctx.moveTo(position - 3 * this.params.cursorWidth + 0.5, -0.5);
          ctx.lineTo(position + 0.5, 8.5);
          ctx.lineTo(position + 0.5, this.cursorCanvas.height + 0.5);
          ctx.lineTo(position + this.params.cursorWidth + 0.5, this.cursorCanvas.height + 0.5);
          ctx.lineTo(position + this.params.cursorWidth + 0.5, 8.5);
          ctx.lineTo(position + 4 * this.params.cursorWidth + 0.5, -0.5);
          ctx.fill();
        }
      }
    }
  }]);
  return Drawer$1;
}(MultiCanvas);
function playbackRateToNumeral(rate) {
  if (rate >= 5) {
    return 5;
  }
  if (rate <= 0.25) {
    return 0.25;
  }
  if (rate > 0.25 && rate < 5) {
    return rate;
  }
  switch (rate) {
    case "very_fast":
      return 1.5;
    case "fast":
      return 1.25;
    case "slow":
      return 0.75;
    case "very_slow":
      return 0.5;
    default:
      return 1.0;
  }
}
var WaveSurfer = WS__default;
var style$1 = WS__default.util.style;
var defaultPlayerOptions = {
  backgroundColor: "#FFFFFF",
  progressBackgroundColor: "rgba(184, 216, 190, 0.5)",
  barWidth: 4,
  barHeight: 0.8,
  barGap: 2,
  cursorWidth: 2,
  cursorColor: "#000",
  height: 56,
  hideScrollbar: true,
  progressColor: "#14972e",
  waveColor: "#14972e",
  regionColor: "#FEE1CC"
};
var PlayerCore = /*#__PURE__*/function (_eventemitter3$EventE) {
  _inherits(PlayerCore, _eventemitter3$EventE);
  var _super4 = _createSuper(PlayerCore);
  function PlayerCore(container) {
    var _this21;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PlayerCore);
    _this21 = _super4.call(this);
    _this21.isHotLoading = false;
    _this21.mediaElement = null;
    _this21.wsHandleAudioProcess = function (currentTime) {
      _this21.emit("process", currentTime);
    };
    _this21.wsHandleError = function (error) {
      _this21.emit("error", error);
    };
    _this21.wsHandleFinish = function () {
      _this21.emit("finish");
    };
    _this21.wsHandlePlay = function () {
      _this21.emit("play");
    };
    _this21.wsHandlePause = function () {
      _this21.emit("pause");
    };
    _this21.wsHandleReady = function () {
      var _a;
      _this21.isHotLoading = false;
      var duration = (_a = _this21.ws) === null || _a === void 0 ? void 0 : _a.getDuration();
      if (duration && _this21.ws && _this21.ws.timeline && _this21.ws.timeline.params) {
        _this21.ws.timeline.params.timeInterval = Math.floor(duration / 60) + duration % 60 / 60;
      }
      _this21.waveform = _this21.waveformContainer.querySelector("wave");
      _this21.waveform.appendChild(_this21.regionsContainer);
      _this21.emit("ready");
      _this21.renderSegmentHighlight();
    };
    _this21.wsHandleRedraw = function () {
      _this21.emit("redraw");
    };
    _this21.wsHandleSeek = function (progress) {
      _this21.emit("seek", progress);
    };
    _this21.renderSegmentHighlight = function () {
      if (_this21.currentSegmentOffset === undefined || _this21.currentSegmentDuration === undefined || !_this21.ws) {
        _this21.segmentHighlighterLeft.style.width = "0";
        _this21.segmentHighlighterCenter.style.width = "0";
        _this21.segmentHighlighterRight.style.flex = "0";
        return;
      }
      var duration = _this21.ws.getDuration();
      var pxPerSec = _this21.container.clientWidth / duration;
      var width = Math.min(_this21.currentSegmentDuration, duration - _this21.currentSegmentOffset) * pxPerSec;
      var offset = _this21.currentSegmentOffset * pxPerSec;
      _this21.segmentHighlighterLeft.style.width = "".concat(offset, "px");
      _this21.segmentHighlighterCenter.style.width = "".concat(width, "px");
      _this21.segmentHighlighterRight.style.flex = "1";
    };
    _this21.timelineFormatter = function (seconds) {
      return defaultTimeFormatter(seconds - (_this21.currentSegmentOffset || 0));
    };
    _this21.destroy = function () {
      if (_this21.ws) {
        _this21.ws.drawer.destroy();
        _this21.ws.destroy();
        while (_this21.timelineContainer.lastChild) {
          _this21.timelineContainer.removeChild(_this21.timelineContainer.lastChild);
        }
        Array.from(_this21.waveformContainer.childNodes).forEach(function (el) {
          if (el.nodeName === "WAVE") {
            _this21.waveformContainer.removeChild(el);
          }
        });
        _this21.ws = undefined;
      }
    };
    _this21.load = function (url) {
      var channels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      _this21.destroy();
      _this21.isHotLoading = false;
      _this21.mediaElement = document.createElement("audio");
      _this21.mediaElement.setAttribute("preload", "metadata");
      _this21.mediaElement.src = url;
      _this21.container.prepend(_this21.mediaElement);
      var ws = _this21.initWS();
      ws.drawer.channels = channels;
      var peaks = ws.drawer.channels.map(function (c) {
        return c.peaks || [];
      });
      if (!peaks.length || peaks.some(function (p) {
        return !p.length;
      })) {
        ws.load(_this21.mediaElement);
      } else {
        ws.load(_this21.mediaElement, peaks);
      }
    };
    _this21.hotLoad = function (url) {
      return new Promise(function (resolve, reject) {
        if (!_this21.ws) {
          reject(new Error("Unable to hotload, because player is either loading or not initialized"));
          return;
        }
        if (!_this21.mediaElement) {
          reject(new Error("Unable to hotload, because media element does not exist"));
          return;
        }
        var time = _this21.ws.getCurrentTime();
        var isPlaying = _this21.isPlaying();
        var rate = _this21.ws.getPlaybackRate();
        _this21.isHotLoading = true;
        var onCanPlay = function onCanPlay() {
          if (_this21.ws && _this21.mediaElement) {
            _this21.ws.backend.seekTo(time);
            _this21.ws.setPlaybackRate(rate);
            if (isPlaying) {
              _this21.ws.backend.play();
            }
            _this21.mediaElement.removeEventListener("canplay", onCanPlay);
            _this21.isHotLoading = false;
            _this21.emit("hot-load");
            resolve(undefined);
          }
        };
        _this21.mediaElement.addEventListener("canplay", onCanPlay);
        _this21.mediaElement.src = url;
      });
    };
    _this21.play = function (start, end) {
      if (!_this21.ws || _this21.isHotLoading) {
        return Promise.reject(new Error("Unable to play, because player is either loading or not initialized"));
      }
      return _this21.ws.play(start !== undefined ? start + (_this21.currentSegmentOffset || 0) : undefined, end !== undefined ? end + (_this21.currentSegmentOffset || 0) : undefined);
    };
    _this21.pause = function () {
      if (!_this21.ws || _this21.isHotLoading) {
        return Promise.reject(new Error("Unable to pause, because player is either loading or not initialized"));
      }
      return _this21.ws.pause() || Promise.resolve();
    };
    _this21.getCurrentTime = function () {
      if (_this21.ws) {
        return _this21.ws.getCurrentTime() - (_this21.currentSegmentOffset || 0);
      }
      return 0;
    };
    _this21.isPlaying = function () {
      if (_this21.ws) {
        return _this21.ws.isPlaying();
      }
      return false;
    };
    _this21.isReady = function () {
      if (_this21.ws) {
        return _this21.ws.isReady;
      }
      return false;
    };
    _this21.seekToSecond = function (seconds) {
      var offsetFromSegment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!_this21.ws || !_this21.isReady() || _this21.isHotLoading) {
        throw new Error("Unable to seek, because player is either loading or not initialized");
      }
      var offset = (offsetFromSegment && _this21.currentSegmentOffset || 0) + seconds;
      return _this21.ws.seekTo(offset / _this21.ws.getDuration());
    };
    _this21.setCurrentSegment = function (duration, offset) {
      if (!_this21.ws) {
        throw new Error("Unable to set current segment, because player is either loading or not initialized");
      }
      var recordingDuration = _this21.ws.getDuration();
      if (!Number.isFinite(recordingDuration) || offset && offset > recordingDuration) {
        console.warn("The offset of the current segment is longer than recording duration", offset, recordingDuration);
        offset = undefined;
        duration = undefined;
      }
      _this21.currentSegmentDuration = duration;
      _this21.currentSegmentOffset = offset;
      _this21.renderSegmentHighlight();
      _this21.seekToSecond(0);
      if (_this21.ws.timeline) {
        _this21.ws.timeline.render();
      }
    };
    _this21.setPlaybackRate = function () {
      var rate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
      if (!_this21.ws) {
        throw new Error("Unable to seek, because player is either loading or not initialized");
      }
      _this21.ws.setPlaybackRate(playbackRateToNumeral(rate));
    };
    _this21.container = container;
    _this21.timelineContainer = document.createElement("div");
    _this21.waveformContainer = document.createElement("div");
    _this21.regionsContainer = style$1(document.createElement("div"), regionsContainerStyles);
    _this21.segmentHighlighterContainer = style$1(document.createElement("div"), segmentHighlighterContainerStyles);
    _this21.segmentHighlighterLeft = style$1(document.createElement("div"), segmentHighlighterLeftStyles);
    _this21.segmentHighlighterCenter = style$1(document.createElement("div"), segmentHighlighterCenterStyles);
    _this21.segmentHighlighterRight = style$1(document.createElement("div"), segmentHighlighterRightStyles);
    _this21.timelineContainer.setAttribute("class", "twilio-player-timeline");
    _this21.waveformContainer.setAttribute("class", "twilio-player-waveform");
    _this21.regionsContainer.setAttribute("class", "twilio-player-regions");
    _this21.segmentHighlighterContainer.setAttribute("class", "twilio-player-segments");
    _this21.segmentHighlighterContainer.appendChild(_this21.segmentHighlighterLeft);
    _this21.segmentHighlighterContainer.appendChild(_this21.segmentHighlighterCenter);
    _this21.segmentHighlighterContainer.appendChild(_this21.segmentHighlighterRight);
    _this21.waveformContainer.appendChild(_this21.segmentHighlighterContainer);
    container.appendChild(_this21.waveformContainer);
    container.appendChild(_this21.timelineContainer);
    var timelineOptions = _objectSpread(_objectSpread(_objectSpread({}, defaultTimelineOptions), opt.timeline), {}, {
      container: _this21.timelineContainer
    });
    var plugins = [TimelinePlugin$1.create(_objectSpread(_objectSpread({}, timelineOptions), {}, {
      formatTimeCallback: _this21.timelineFormatter
    }))];
    var wsParams = _objectSpread(_objectSpread(_objectSpread({}, defaultPlayerOptions), opt), {}, {
      container: _this21.waveformContainer,
      backend: "MediaElement",
      mediaType: "audio",
      normalize: true,
      plugins: plugins,
      removeMediaElementOnDestroy: true,
      renderer: Drawer$1,
      splitChannels: true
    });
    _this21.wsParams = wsParams;
    return _this21;
  }
  _createClass(PlayerCore, [{
    key: "initWS",
    value: function initWS() {
      this.ws = WaveSurfer.create(this.wsParams);
      this.ws.on("pause", this.wsHandlePause);
      this.ws.on("play", this.wsHandlePlay);
      this.ws.on("ready", this.wsHandleReady);
      this.ws.on("seek", this.wsHandleSeek);
      this.ws.on("error", this.wsHandleError);
      this.ws.on("finish", this.wsHandleFinish);
      this.ws.on("audioprocess", this.wsHandleAudioProcess);
      this.ws.on("redraw", this.wsHandleRedraw);
      return this.ws;
    }
  }]);
  return PlayerCore;
}(eventemitter3.EventEmitter);
function removeUndefined(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
var Portal = function Portal(props) {
  return reactDom.createPortal(props.children, props.node);
};
var MarkContext = React.createContext({
  segmentOffset: 0,
  pxPerSec: 0,
  containerWidth: 0,
  regionsContainer: null
});
var Mark = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Mark, _React$PureComponent);
  var _super5 = _createSuper(Mark);
  function Mark() {
    _classCallCheck(this, Mark);
    return _super5.apply(this, arguments);
  }
  _createClass(Mark, [{
    key: "render",
    value: function render() {
      var _this22 = this;
      var _this$props = this.props,
        children = _this$props.children,
        offset = _this$props.offset,
        color = _this$props.color,
        title = _this$props.title;
      return React.createElement(MarkContext.Consumer, null, function (_ref8) {
        var pxPerSec = _ref8.pxPerSec,
          containerWidth = _ref8.containerWidth,
          regionsContainer = _ref8.regionsContainer,
          segmentOffset = _ref8.segmentOffset;
        return offset * pxPerSec <= containerWidth ? React.createElement(React.Fragment, null, children && React.createElement("div", {
          style: _objectSpread(_objectSpread({}, _this22.positionElementStyles(pxPerSec, containerWidth, _this22.props.offsetFromSegment ? segmentOffset : 0)), {}, {
            pointerEvents: "none",
            zIndex: 6
          })
        }, children), regionsContainer && React.createElement(Portal, {
          node: regionsContainer
        }, React.createElement("div", {
          title: title,
          style: _objectSpread(_objectSpread({}, _this22.positionElementStyles(pxPerSec, containerWidth, _this22.props.offsetFromSegment ? segmentOffset : 0)), {}, {
            backgroundColor: color
          })
        }))) : null;
      });
    }
  }, {
    key: "positionElementStyles",
    value: function positionElementStyles(pxPerSec, containerWidth, segmentOffset) {
      return {
        position: "absolute",
        top: "0",
        left: (this.props.offset + segmentOffset) * pxPerSec + "px",
        width: Math.min(this.props.duration * pxPerSec, containerWidth - (this.props.offset + segmentOffset) * pxPerSec) + "px",
        height: "100%"
      };
    }
  }]);
  return Mark;
}(React.PureComponent);
Mark.defaultProps = {
  duration: 0,
  color: "transparent",
  offsetFromSegment: false
};
var Player = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(Player, _React$PureComponent2);
  var _super6 = _createSuper(Player);
  function Player() {
    var _this23;
    _classCallCheck(this, Player);
    _this23 = _super6.apply(this, arguments);
    _this23.state = {
      isReady: false
    };
    _this23.container = React.createRef();
    _this23.mediaElement = null;
    _this23.on = function (event, fn) {
      if (!_this23.core) {
        throw new Error("Cannot add listeners before Player is mounted");
      }
      return _this23.core.on(event, fn);
    };
    _this23.once = function (event, fn) {
      if (!_this23.core) {
        throw new Error("Cannot add listeners before Player is mounted");
      }
      return _this23.core.once(event, fn);
    };
    _this23.off = function (event, fn) {
      if (!_this23.core) {
        throw new Error("Cannot remove listeners before Player is mounted");
      }
      return _this23.core.off(event, fn);
    };
    _this23.getCurrentTime = function () {
      var _a;
      return (_a = _this23.core) === null || _a === void 0 ? void 0 : _a.getCurrentTime();
    };
    _this23.isPlaying = function () {
      var _a;
      return ((_a = _this23.core) === null || _a === void 0 ? void 0 : _a.isPlaying()) || false;
    };
    _this23.isReady = function () {
      var _a;
      return ((_a = _this23.core) === null || _a === void 0 ? void 0 : _a.isReady()) || false;
    };
    _this23.play = function (start, end) {
      if (!_this23.core) {
        throw new Error("Player.play() cannot be called before the component is mounted");
      }
      return _this23.core.play(start, end);
    };
    _this23.pause = function () {
      if (!_this23.core) {
        throw new Error("Player.pause() cannot be called before the component is mounted");
      }
      return _this23.core.pause();
    };
    _this23.seekToSecond = function (seconds) {
      var offsetFromSegment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!_this23.core) {
        throw new Error("Player.seekToSecond() cannot be called before the component is mounted");
      }
      return _this23.core.seekToSecond(seconds, offsetFromSegment);
    };
    _this23.getCurrentSegment = function () {
      if (_this23.props.segments) {
        if (_this23.props.currentSegment) {
          var segment = _this23.props.segments.find(function (s) {
            return s.id === _this23.props.currentSegment;
          });
          if (segment) {
            return [segment.duration, segment.offset];
          }
        }
        return [_this23.props.segments[0].duration, _this23.props.segments[0].offset];
      }
      return [0, 0];
    };
    _this23.onReady = function () {
      var _this23$getCurrentSeg = _this23.getCurrentSegment(),
        _this23$getCurrentSeg2 = _slicedToArray(_this23$getCurrentSeg, 2),
        duration = _this23$getCurrentSeg2[0],
        offset = _this23$getCurrentSeg2[1];
      _this23.core.setCurrentSegment(duration, offset);
      if (_this23.props.onReady) {
        _this23.props.onReady(_assertThisInitialized(_this23));
      }
      _this23.setState({
        isReady: true
      });
    };
    _this23.onError = function (e) {
      if (_this23.props.onError) {
        _this23.props.onError(e);
      }
    };
    _this23.onRedraw = function () {
      _this23.forceUpdate();
    };
    _this23.setPlaybackRate = function (rate) {
      return _this23.core.setPlaybackRate(rate);
    };
    return _this23;
  }
  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.core = new PlayerCore(this.container.current, removeUndefined(this.props.options || {}));
      this.mediaElement = this.core.mediaElement;
      this.core.on("ready", this.onReady);
      this.core.on("redraw", this.onRedraw);
      this.core.on("error", this.onError);
      this.load();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.core.destroy();
      this.core.removeAllListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.recordingUrl !== this.props.recordingUrl) {
        var url = new URL(prevProps.recordingUrl);
        var prevUrl = new URL(this.props.recordingUrl);
        if (url.origin + url.pathname === prevUrl.origin + prevUrl.pathname) {
          this.core.hotLoad(this.props.recordingUrl);
        } else {
          return this.load();
        }
      }
      if (prevProps.currentSegment !== this.props.currentSegment) {
        var _this$getCurrentSegme = this.getCurrentSegment(),
          _this$getCurrentSegme2 = _slicedToArray(_this$getCurrentSegme, 2),
          duration = _this$getCurrentSegme2[0],
          offset = _this$getCurrentSegme2[1];
        this.core.setCurrentSegment(duration, offset);
      }
      if (prevProps.playbackRate !== this.props.playbackRate) {
        this.setPlaybackRate(this.props.playbackRate);
      }
    }
  }, {
    key: "load",
    value: function load() {
      if (this.state.isReady) {
        this.setState({
          isReady: false
        });
      }
      this.core.load(this.props.recordingUrl, this.props.channels);
      this.core.setPlaybackRate(this.props.playbackRate);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.container,
        className: "twilio-player-container",
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          position: "relative"
        })
      }, React.createElement("div", {
        className: "twilio-player-markings"
      }, this.state.isReady && this.container.current && this.core.ws && React.createElement(MarkContext.Provider, {
        value: {
          segmentOffset: this.getCurrentSegment()[1],
          containerWidth: this.container.current.clientWidth,
          pxPerSec: this.container.current.clientWidth / this.core.ws.getDuration(),
          regionsContainer: this.core.regionsContainer
        }
      }, this.props.children)));
    }
  }]);
  return Player;
}(React.PureComponent);
exports.Mark = Mark;
exports.Player = Player;
exports.defaultTimeFormatter = defaultTimeFormatter;